module.exports = __webpack_public_path__ + "static/media/www.lauste.fi.63bcdc40.svg";